import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarAsesorByIDRequest } from '../../models/cotizador-contratante/consultar-asesor/request/consultar-asesor-byID-request.model';
import { ConsultarAsesorByIDResponse } from '../../models/cotizador-contratante/consultar-asesor/response/consultar-asesor-byID-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarAsesorByIDService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CONSULTAR_ASESOR_BY_ID}`;

  constructor(private httpClient: HttpClient) { }

  consultarAsesorByID(request: ConsultarAsesorByIDRequest): Observable<ConsultarAsesorByIDResponse> {
    return this.httpClient.post<ConsultarAsesorByIDResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarAsesorByID: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar asesor por ID'));
      })
    );
  }
}
